import {
  FaRobot,
  FaRegLightbulb,
  FaChartLine,
  FaUserCheck,
  FaClock,
  FaHandshake,
  FaUsers,
  FaClipboardList,
  FaFileAlt,
  FaCloud,
  FaPaperPlane,
  FaChartBar,
  FaPlayCircle,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import Homepic2 from "../assets/HomePics/Homepic2.png";
import Homepic1 from "../assets/HomePics/Homepic1.jpg";
import topright from "../assets/HomePics/topRight.png";
import bottomright from "../assets/HomePics/bottomRight.png";
import bottomleft from "../assets/HomePics/bottomLeft.png";
import Homepic3 from "../assets/HomePics/Homepic3.png";
import bg1 from "../assets/BackgroundImages/BG image 1.png";
import bg2 from "../assets/BackgroundImages/BG image 2.png";
import bg6 from "../assets/BackgroundImages/BG image 6.png";
import { LampContainer } from "../components/LampContainer";
import topLeft2 from "../assets/HomePics/topLeft2.jpg";
import SmallCard from "../components/SmallCard";
import CookieConsentPopup  from "../components/CookieConsentPopup";
const Home = () => {
  return (
    <main className="pt-30 md:pt-25">
      {/* Hero Section */}
      <CookieConsentPopup />

      <div className="min-h-[calc(100vh-80px)] flex flex-col justify-center items-center text-center bg-[#102742] ">
        {/* Content Wrapper */}
        <div className="flex flex-col md:flex-row justify-center items-center text-center md:text-left w-full md:max-w-8xl">
          {/* Left Content (Text) */}
          <div className="flex flex-col items-center md:items-start text-center md: md:text-left px-10 md:pl-30">
            <h1 className="text-4xl sm:text-5xl font-bold">
              Smarter Hiring,
              <br /> Faster Growth.
            </h1>
            <p className="text-lg mt-4 max-w-md sm:max-w-lg">
              Find, track, and hire top talent with AI-powered recruitment
              software.
              <br />
              Save time, reduce hiring costs, and build your dream team with an
              all-in-one hiring.
            </p>
            <div className="mt-6 flex flex-wrap gap-4 justify-center md:justify-start">
              {/* Demo Button */}
              <Link to="/contact">
                <button className="bg-[#19BFB7] flex items-center gap-2 border-2 border-[#19BFB7] rounded-full py-2 px-6 text-white hover:bg-white hover:text-[#0f1d35] transition duration-300 transform hover:scale-105">
                  <FaPlayCircle /> Request a Demo
                </button>
              </Link>
            </div>
          </div>

          {/* Right Image (Takes More Space) */}
          <div className="hidden md:flex justify-right">
            <img
              src={Homepic1}
              alt="AI Recruitment"
              className="w-full h-auto object-contain max-w-[800px] md:max-w-[900px] lg:max-w-[1000px]"
            />
          </div>
        </div>

        {/* Second Image Below Content */}
        <div className="max-w-[1200px]">
          <img
            src={Homepic2}
            alt="AI Recruitment"
            className="w-full h-auto object-contain"
          />
        </div>

        {/* Description Text */}
        <div className="-mt-5 md:-mt-25 py-5 w-full max-w-xl w-[90%] max-w-lg mx-auto bg px-10">
          <p>
            <strong>AIAURA</strong> is an all-in-one{" "}
            <strong>AI-driven recruitment and HR platform</strong> designed to
            optimize hiring, streamline workflows, and enhance decision-making
            for companies. It helps both individuals in their roles and
            businesses as a whole by leveraging{" "}
            <strong>
              AI-powered analytics, automation, and seamless integration with
              existing systems.
            </strong>
          </p>
        </div>
      </div>

      {/* Background Images */}

      <div>
        <div className="-z-10 absolute right-0 h-full opacity-50 translate-y-[-200px]">
          <img src={bg1} alt="bg" className="h-full w-auto object-contain" />
        </div>

        {/* Background Images */}
        <div className="-z-10 absolute left-0 h-full opacity-50 md:translate-y-0">
          <img src={bg2} alt="bg" className="h-full w-auto object-contain" />
        </div>

        {/* Background Images */}

        <div className="-z-10 absolute left-0 h-full opacity-50 translate-y-80 md:translate-y-100">
          <img src={bg2} alt="bg" className="h-full w-auto object-contain" />
        </div>

        <h1 className="text-5xl font-bold  text-center mt-50">
          Why Choose <span className="text-[#19BFB7]">AIAURA</span>
        </h1>
        <p className="text-center pt-3 ">
          Find, Track and Hire Top Talent with AI-Powered Recruitement Software
        </p>
      </div>
      <div className="flex justify-center items-center min-h-screen p-3 ">
        <div className="flex flex-col p-5 sm:grid grid-cols-4 gap-4 max-w-6xl mx-auto ">
          {/* Top Left - Smaller */}

          <div
            className="col-span-1 rounded-xl overflow-hidden p-5 relative h-full flex flex-col justify-end shadow-lg"
            style={{
              backgroundImage: `url(${topLeft2})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            {/* Icon at the top-left */}
            <div className="absolute top-4 left-4 w-8 h-8 rounded-full bg-white flex items-center justify-center shadow-md z-20">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                className="w-4 h-4 text-[#2CA6A4]"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M8.25 4.5l7.5 7.5-7.5 7.5"
                />
              </svg>
            </div>

            {/* Main Content */}
            <div className="backdrop-blur-lg bg-white/20 p-4 rounded-lg shadow-md relative z-10 mt-8">
              <h3 className="text-white font-semibold text-sm mb-2">
                Custom Reports & Analytics
              </h3>
              <p className="text-white text-xs">
                Make data-driven hiring decisions with detailed insights.
              </p>
            </div>
          </div>

          {/* Top Right - Longer */}
          <div className="col-span-3 rounded-xl overflow-hidden bg-[#18406e] p-3">
            <h1 className=" text-xl text-center md:text-left">
              Automated Workflows
            </h1>
            <p className="py-3  text-xs text-center pt-3 md:py-0 md:text-left">
              Reduce manual tasks with smart scheduling and candidate tracking
            </p>
            <img
              src={topright} // Replace with your image URL
              alt="Top Right"
              className="w-full h-full object-contain md:py-7"
            />
          </div>

          {/* Bottom Left - Longer */}
          <div className="col-span-3 rounded-xl overflow-hidden bg-[#18406e] p-3">
            <h1 className=" text-xl text-center md:text-left">
              One-Click Job Posting{" "}
            </h1>
            <p className="py-3  text-xs text-center pt-3 md:py-0 md:text-left">
              Publish your job openings across 100+ job boards effortlessly.
            </p>
            <img
              src={bottomleft} // Replace with your image URL
              alt="Bottom Left"
              className="w-full h-full object-contain md:py-7"
            />
          </div>

          {/* Bottom Right - Smaller */}
          <div className="col-span-1 rounded-xl overflow-hidden bg-[#18406e] p-3">
            <h1 className=" text-xl text-center md:text-left">
              AI-Powered Talent Hosting{" "}
            </h1>
            <p className="py-3 text-xs text-center pt-3 md:py-0 md:text-left">
              Instantly discover the best candidates for every role
            </p>
            <img
              src={bottomright} // Replace with your image URL
              alt="Bottom Right"
              className="w-full h-full object-contain md:py-7"
            />
          </div>
        </div>
      </div>

      <div className="px-10 md:px-20 flex flex-col gap-5">
        {/* Background Images */}
        <div className="-z-10 absolute h-full opacity-45 right-0 translate-y-[150px] md:translate-x-[-100px] md:translate-y-[100px]">
          <img src={bg2} alt="bg" className="h-full w-auto object-contain" />
        </div>

        <div className=" hidden md:block -z-10 absolute h-full opacity-35 right-0 md:translate-y-[100px]">
          <img src={bg6} alt="bg" className="h-full w-auto object-contain" />
        </div>
        <div className="mt-8 bg-[#11243b] p-4 rounded-lg border-l-4 border-cyan-400">
          <p className="text-gray-300 italic text-center">
            "From Hiring to Retention - AI That Builds Stronger Teams"
          </p>
        </div>
        <h1 className="text-5xl font-bold mt-50">
          For <span className="text-[#19BFB7]">Growing</span> Companies
        </h1>
        <p>Scale hiring effortlessly with automation and AI tools.</p>
        <Link to="/contact">
  <button className="border border-white px-6 py-2 rounded-lg hover:bg-[#009C97] hover:border-[#009C97] hover:shadow-xl transition duration-500 self-start transition-transform transform hover:scale-105">
    Request Demo
  </button>
  </Link>
      </div>
      <div className="pl-10 py-5 flex flex-col gap-5">
        <img
          src={Homepic3}
          alt="homepic3"
          className="w-full h-full max-w-[1200px] mx-auto h-auto object-contain"
        ></img>
      </div>

      {/*Glowing bar*/}
      <div className="flex flex-col justify-center items-center">
        <div className="w-[70%] h-2 rounded-full bg-white shadow-[0_0_20px_5px_rgba(255,255,255,0.7)] mt-50 mb-20 md:mb-30">
          <div
            className=" absolute z-[-10] 
      w-[70%] max-w-[1200px] h-[300px] sm:h-[350px] md:h-[400px] lg:h-[500px] 
      bg-[radial-gradient(farthest-side_at_top,teal,#0000)] mx-auto"
          ></div>
        </div>

        <h1 className="text-5xl font-bold text-center">
          How <span className="text-[#19BFB7]">AIAURA</span> Transforms Your
          Hiring Process
        </h1>
        <p className="text-center pt-5">
          {" "}
          Discover how AIAURA's AI-driven recruitment solutions streamline your
          hiring process, enhance candidate quality, and empower you to make
          data-backed decisions effortlessly.
        </p>

        {/* Background Images */}
        <div className="-z-10 absolute h-full opacity-45 right-0 translate-y-[400px]">
          <img src={bg1} alt="bg" className="h-full w-auto object-contain" />
        </div>
        <div className="-z-10 absolute h-full opacity-45 left-0 translate-y-[1200px] md:translate-x-[-100px] md:translate-y-[400px]">
          <img src={bg2} alt="bg" className="h-full w-auto object-contain" />
        </div>
      </div>

      <div className="flex justify-center items-center p-3 pb-20">
        <div className="flex flex-col p-5 sm:grid grid-cols-2 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {/* Faster Hiring */}
          <div className="rounded-xl overflow-hidden bg-[#18406e] p-5 flex flex-col items-center text-center transition-transform transform hover:scale-105">
            <FaClock className="text-4xl text-[#19BFB7] mb-3" />
            <h1 className="text-xl font-bold">Faster Hiring</h1>
            <p className="py-2 text-sm">
              Reduce time-to-hire with AI-driven automation and smart
              recommendations.
            </p>
          </div>

          {/* Better Quality Candidates */}
          <div className="rounded-xl overflow-hidden bg-[#18406e] p-5 flex flex-col items-center text-center transition-transform transform hover:scale-105">
            <FaUserCheck className="text-4xl text-[#19BFB7] mb-3" />
            <h1 className="text-xl font-bold">Better Quality Candidates</h1>
            <p className="py-2 text-sm">
              Find top talent with precision-matching technology.
            </p>
          </div>

          {/* Predictive Hiring Analytics */}
          <div className="rounded-xl overflow-hidden bg-[#18406e] p-5 flex flex-col items-center text-center transition-transform transform hover:scale-105">
            <FaChartLine className="text-4xl text-[#19BFB7] mb-3" />
            <h1 className="text-xl font-bold">Predictive Hiring Analytics</h1>
            <p className="py-2 text-sm">
              Gain insights into hiring trends and candidate success rates.
            </p>
          </div>

          {/* Unbiased Hiring Decisions */}
          <div className="rounded-xl overflow-hidden bg-[#18406e] p-5 flex flex-col items-center text-center transition-transform transform hover:scale-105">
            <FaRegLightbulb className="text-4xl text-[#19BFB7] mb-3" />
            <h1 className="text-xl font-bold">Unbiased Hiring Decisions</h1>
            <p className="py-2 text-sm">
              Reduce bias with AI-driven evaluations based on skills and
              experience.
            </p>
          </div>

          {/* Proactive Talent Sourcing */}
          <div className="rounded-xl overflow-hidden bg-[#18406e] p-5 flex flex-col items-center text-center transition-transform transform hover:scale-105">
            <FaRobot className="text-4xl text-[#19BFB7] mb-3" />
            <h1 className="text-xl font-bold">Proactive Talent Sourcing</h1>
            <p className="py-2 text-sm">
              Scan talent pools to recommend candidates before competitors do.
            </p>
          </div>

          {/* Seamless Onboarding Integration */}
          <div className="rounded-xl overflow-hidden bg-[#18406e] p-5 flex flex-col items-center text-center transition-transform transform hover:scale-105">
            <FaHandshake className="text-4xl text-[#19BFB7] mb-3" />
            <h1 className="text-xl font-bold">
              Seamless Onboarding Integration
            </h1>
            <p className="py-2 text-sm">
              Integrate smoothly with onboarding workflows.
            </p>
          </div>
        </div>
      </div>

      <SmallCard />

      <div className="relative flex flex-col items-center py-20">
        {/* Glowing Bar */}
        <div className="w-[70%] h-2 rounded-full bg-white shadow-[0_0_20px_5px_rgba(255,255,255,0.7)] relative">
          <div
            className=" absolute z-[-10] opacity-70
      w-[100%] max-w-[1200px] h-[300px] sm:h-[350px] md:h-[400px] lg:h-[500px] 
      bg-[radial-gradient(farthest-side_at_top,teal,#0000)] mx-auto"
          ></div>
        </div>

        <h1 className="mt-10 text-4xl font-bold text-center text-white relative z-10 pt-5">
          How <span className="text-teal-400">AIAURA</span> Helps?
        </h1>
        <p className="mt-4 text-center text-white/80 max-w-xl relative z-10">
          AIAURA cuts down manual tasks, reduces time-to-hire, and boosts
          candidate engagement through personalized, automated outreach.
        </p>

        {/*Background Images*/}
        <div className=" -z-10 absolute h-full opacity-50 right-0 translate-y-[50px] ">
          <img src={bg1} alt="bg" className="h-full w-auto object-contain" />
        </div>

        <div className=" -z-10 absolute h-full opacity-50 left-0 translate-y-[700px]  md:translate-y-[170px]">
          <img src={bg2} alt="bg" className="h-full w-auto object-contain" />
        </div>

        <div className="flex flex-col p-5 sm:grid grid-cols-2 md:grid-cols-3 gap-6 max-w-6xl mx-auto ">
          {/* Shared Talent Pool */}
          <div className="rounded-xl overflow-hidden bg-[#18406e] p-5 flex flex-col items-center text-center transition-transform transform hover:scale-105">
            <FaUsers className="text-4xl text-[#19BFB7] mb-3" />
            <h3 className="text-xl font-bold">Shared Talent Pool</h3>
            <p className="py-2 text-sm">
              Allow recruitment teams to collaboratively build and manage a
              centralized talent pool, reducing duplicate efforts.
            </p>
          </div>

          {/* Automated Follow-Ups */}
          <div className="rounded-xl overflow-hidden bg-[#18406e] p-5 flex flex-col items-center text-center transition-transform transform hover:scale-105">
            <FaPaperPlane className="text-4xl text-[#19BFB7] mb-3" />
            <h3 className="text-xl font-bold">Automated Follow-Ups</h3>
            <p className="py-2 text-sm">
              Schedule follow-up emails or messages to maintain candidate
              engagement throughout the hiring process.
            </p>
          </div>

          {/* Hiring Trend Analysis */}
          <div className="rounded-xl overflow-hidden bg-[#18406e] p-5 flex flex-col items-center text-center transition-transform transform hover:scale-105">
            <FaChartBar className="text-4xl text-[#19BFB7] mb-3" />
            <h3 className="text-xl font-bold">Hiring Trend Analysis</h3>
            <p className="py-2 text-sm">
              Offer predictive analytics to identify trends, such as peak hiring
              times or in-demand skills.
            </p>
          </div>

          {/* Automated Job Posting */}
          <div className="rounded-xl overflow-hidden bg-[#18406e] p-5 flex flex-col items-center text-center transition-transform transform hover:scale-105">
            <FaClipboardList className="text-4xl text-[#19BFB7] mb-3" />
            <h3 className="text-xl font-bold">Automated Job Posting</h3>
            <p className="py-2 text-sm">
              Multi-channel job postings to platforms like LinkedIn, Indeed, and
              niche job boards.
            </p>
          </div>

          {/* Digital Onboarding */}
          <div className="rounded-xl overflow-hidden bg-[#18406e] p-5 flex flex-col items-center text-center transition-transform transform hover:scale-105">
            <FaFileAlt className="text-4xl text-[#19BFB7] mb-3" />
            <h3 className="text-xl font-bold">Digital Onboarding</h3>
            <p className="py-2 text-sm">
              Manage contracts, offer letters, and onboarding checklists
              directly within AIAURA.
            </p>
          </div>

          {/* Scalable Infrastructure */}
          <div className="rounded-xl overflow-hidden bg-[#18406e] p-5 flex flex-col items-center text-center transition-transform transform hover:scale-105">
            <FaCloud className="text-4xl text-[#19BFB7] mb-3" />
            <h3 className="text-xl font-bold">Scalable Infrastructure</h3>
            <p className="py-2 text-sm">
              Cloud-based architecture to support growing recruitment needs
              without compromising performance.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Home;
